<template>
    <div class="steps">
        <div
            :class="['step-item', currentStep >= index ? 'active' : '', currentStep > index ? 'active-line' : '']"
            v-for="(step, index) in steps"
            :key="index"
        >
            <span :class="['icon', step.icon]"></span>
            <p>{{ step.title }}</p>
            <i class="line"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStep: {
            type: Number,
            default: 0,
        },
        steps: {
            type: Array,
            default: () => [],
        },
    },
    components: {},
    data() {
        return {
            pageLoading: false,
        };
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.steps {
    display: flex;
    width: 100%;
    margin-bottom: 50px;

    .step-item {
        flex: 1;
        text-align: center;
        position: relative;

        .line {
            width: 86%;
            position: absolute;
            background: $--color-border-gary;
            height: 1px;
            right: -43%;
            top: 10px;

            &::after,
            &::before {
                content: '';
                position: absolute;
                width: 7px;
                height: 7px;
                background: $--color-border-gary;
                right: 0px;
                border-radius: 50%;
                top: -3px;
            }

            &::before {
                left: 0px;
            }

            &::after {
                right: 0px;
            }
        }

        &:last-child .line {
            display: none;
        }

        .icon {
            width: 20px;
            height: 20px;
            display: inline-block;
            margin-bottom: 14px;

            &.icon_info {
                background-image: url('~@/assets/img/enterprises/icon_info_disable.svg');
            }

            &.icon_phone {
                background-image: url('~@/assets/img/enterprises/icon_phone_disable.svg');
            }

            &.icon_over {
                background-image: url('~@/assets/img/enterprises/icon_over_disable.svg');
            }

            &.icon_book {
                background-image: url('~@/assets/img/enterprises/icon_book_disable.svg');
            }

            &.icon_pay {
                background-image: url('~@/assets/img/enterprises/icon_pay_disable.svg');
            }

            &.icon_bank {
                background-image: url('~@/assets/img/enterprises/icon_bank_disable.svg');
            }
        }

        p {
            color: $--color-font-disable;
            line-height: 12px;
            font-size: 12px;
        }

        &.active-line {
            .line {
                background: $--color-border-black;

                &::after,
                &::before {
                    background: $--color-border-black;
                }
            }
        }

        &.active {
            p {
                color: $--color-font-normal;
            }

            .icon {
                &.icon_info {
                    background-image: url('~@/assets/img/enterprises/icon_info.svg');
                }

                &.icon_phone {
                    background-image: url('~@/assets/img/enterprises/icon_phone.svg');
                }

                &.icon_over {
                    background-image: url('~@/assets/img/enterprises/icon_over.svg');
                }

                &.icon_book {
                    background-image: url('~@/assets/img/enterprises/icon_book.svg');
                }

                &.icon_pay {
                    background-image: url('~@/assets/img/enterprises/icon_pay.svg');
                }

                &.icon_bank {
                    background-image: url('~@/assets/img/enterprises/icon_bank.svg');
                }
            }
        }
    }
}
</style>
